import { Modal, Button } from 'react-bootstrap';
import { UploadImageContainer, UploadAndDisplayImage2 } from './upload-image';
import { useState } from "react";

export const ImageUploadModal = (props) => {

    const [imageCollection, setImageCollection] = useState([]);

    return props.show &&
        (
            <Modal
                show={props.show}
                onHide={props.handleCancel}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Images (max {props.maxFileCount ?? 10})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UploadImageContainer>
                        <UploadAndDisplayImage2 addImage={collection => { setImageCollection(collection) }} maxFileCount={props.maxFileCount ?? 10}  />
                    </UploadImageContainer>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: 'start' }}>
                    <div className='col-xl-7'>
                        {props.imageUploadInProgress && props.imageUploadProgress === 0 && <div>Starting upload... please wait</div> }
                        {props.imageUploadProgress > 0 && <div className="progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{ width: props.imageUploadProgress * 100 + '%' }}>{`${(props.imageUploadProgress * 100).toFixed(2)}%`}</div>}
                    </div>
                    <div className='btn-group col-xl-4'>
                        <Button className='me-15px' variant="secondary" onClick={() => { props.handleCancel(); }}>
                            Cancel
                        </Button>

                        <Button variant="primary" onClick={() => { props.handleSave(imageCollection); }}>
                            <i className="fa fa-save fa-lg me-2 ms-n2 text-success-900"></i>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
}